





































































import { VNode } from 'vue';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class AdvancedSearchComponent extends Vue {
  @Prop(Boolean) readonly loading!: boolean;

  displayAdvancedSearch = false;

  toggleAdvancedSearch(): void {
    this.displayAdvancedSearch = !this.displayAdvancedSearch;
  }

  get inputFields(): string[] {
    return this.$slots['advanced-search'] && Array.isArray(this.$slots['advanced-search'])
      ? this.$slots['advanced-search'].filter(
        (node: VNode) => node.children,
      ).map((node: VNode) => {
        /* eslint-disable @typescript-eslint/no-explicit-any */
        const vNode: any = node.children;
        if (vNode && Array.isArray(vNode)) {
          return Array.isArray(vNode[0].data?.model.value)
            ? vNode[0].data?.model.value.join(',')
            : vNode[0].data?.model.value;
        }
        return [];
      }) : [];
  }

  get showAdvancedSearchDirtyIcon(): boolean {
    return this.inputFields.some((v) => v) && !this.displayAdvancedSearch;
  }
}
